import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-021cbfa2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "n-tabs"
};
const _hoisted_2 = ["onMouseover"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "tabs-container"
};
const _hoisted_5 = {
  class: "tab-pane"
};
const _hoisted_6 = {
  class: "code-container"
};
const _hoisted_7 = ["src"];
import { ref, onMounted, watch } from 'vue';
import { $track } from '@/plugins/Track';
export default {
  __name: 'appList',
  setup(__props) {
    const applist = ref([{
      name: '小程序',
      msg: '使用微信扫一扫',
      code: require('@/assets/img/xcx-code.jpg'),
      iconSrc: require('@/assets/img/applet.svg'),
      csname: 'applet active'
    }, {
      name: '公众号',
      msg: '使用微信扫一扫',
      code: require('@/assets/img/gzh-code.png'),
      iconSrc: require('@/assets/img/official.svg'),
      csname: 'official'
    }, {
      name: '视频号',
      msg: '使用微信扫一扫',
      code: require('@/assets/img/sph-code.png'),
      iconSrc: require('@/assets/img/video.svg'),
      csname: 'video'
    }, {
      name: '企业微信',
      msg: '使用微信扫一扫',
      code: require('@/assets/img/qw-code.png'),
      iconSrc: require('@/assets/img/wecom.svg'),
      csname: 'wecom'
    }, {
      name: '抖音',
      msg: '使用抖音扫一扫',
      code: require('@/assets/img/dy-code.svg'),
      iconSrc: require('@/assets/img/douyin.svg'),
      csname: 'douyin'
    }, {
      name: '支付宝',
      msg: '使用支付宝扫一扫',
      code: require('@/assets/img/alipay-code.png'),
      iconSrc: require('@/assets/img/alipay.svg'),
      csname: 'alipay'
    }, {
      name: '钉钉',
      msg: '使用钉钉扫一扫',
      code: require('@/assets/img/dingding-code.png'),
      iconSrc: require('@/assets/img/dingding.svg'),
      csname: 'dingding'
    }, {
      name: '客户端',
      msg: '点击打开客户端页',
      code: require('@/assets/img/khd-code.svg'),
      iconSrc: require('@/assets/img/client.svg'),
      csname: 'client'
    }]);
    const activeKey = ref(0);
    const changeKey = val => {
      activeKey.value = val;
    };
    const current = ref(null);
    watch(activeKey, (nv, lv) => {
      applist.value[nv].csname += ' active';
      const lastcs = applist.value[lv].csname;
      applist.value[lv].csname = lastcs.replace(' active', '');
      current.value = applist.value[nv];

      // 上报用户行为
      $track('WebsiteUsersClick', {
        button_name: `悬停${current.value.name}`,
        click_info: current.value.name,
        event_source: '顶部导航',
        event_target: '扫码',
        event_target_pam: null,
        event_source_pam: null
      });
    });

    // 特定信息点击跳转
    const jumpTo = code => {
      if (code.includes('client')) {
        return goPage('loginUrl');
      }
    };
    onMounted(() => {
      current.value = applist.value.find((item, index) => index === activeKey.value);
    });
    const goPage = async url => {
      window.open(window.appConfig[url], '_blank');
    };
    return (_ctx, _cache) => {
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      return _openBlock(), _createBlock(_component_a_dropdown, {
        class: "min-app"
      }, {
        overlay: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applist.value, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            class: _normalizeClass(item.csname),
            key: index,
            onMouseover: $event => changeKey(index)
          }, [_createElementVNode("span", null, [_createElementVNode("img", {
            src: item.iconSrc
          }, null, 8, _hoisted_3)]), _createTextVNode(" " + _toDisplayString(item.name), 1)], 42, _hoisted_2);
        }), 128))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: current.value.code,
          onClick: _cache[1] || (_cache[1] = $event => jumpTo(current.value.csname))
        }, null, 8, _hoisted_7)]), _createElementVNode("p", {
          onClick: _cache[2] || (_cache[2] = $event => jumpTo(current.value.csname))
        }, _toDisplayString(current.value.msg), 1)])])])]),
        default: _withCtx(() => [_createElementVNode("a", {
          class: "ant-dropdown-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, " 客户端/小程序 ")]),
        _: 1
      });
    };
  }
};